import { useState } from "react";
import VoiceGainAuthSvcApi from "../../../../apis/VoiceGainAuthSvcApi";
import { AccountStatus, IAccountsList } from "../../MainContent.types";
import styles from "./styled.module.css";
import { Button } from "antd";
import { message } from "antd";
import { useSWRConfig } from "swr";
import { Checkbox } from "antd";
import { fetchAccount } from "../../../../apis/swr/fetchers";

export const saFeatures = [
  { name: "billing", label: "Billing" },
  { name: "qa_form_settings", label: "QA Form Settings" },
  { name: "qa_form_score", label: "QA Form Score" },
  { name: "teams_page", label: "Teams Page" },
  { name: "user_setting_team", label: "User Setting Team" },
  { name: "add_project", label: "Add Project" },
  { name: "integration_aircall", label: "Integration Aircall" },
  { name: "integration_s3", label: "Integration S3" },
  { name: "integration_more", label: "Integration More" },
];

interface IAccountSAProps {
  account: IAccountsList | undefined;
}

function AccountSA({ account }: IAccountSAProps) {
  const { mutate } = useSWRConfig();

  const status = account && account.status ? account.status : "";
  const accountId = account && account.accountId ? account.accountId : "";

  const [hiddenFeatures, setHiddenFeatures] = useState(
    account && account.saAppHiddenFeatures ? account.saAppHiddenFeatures : []
  );

  const [isLoading, setIsLoading] = useState(false);

  const showActivateButton = status === "pending";

  async function handleActivateAccount() {
    if (!isLoading) {
      setIsLoading(true);
      const activateAccountResponse = await VoiceGainAuthSvcApi.modAccount(
        accountId,
        { status: AccountStatus.Active }
      );
      if (activateAccountResponse.ok) {
        await mutate([fetchAccount, accountId]);
        message.success("Account activated successfully");
        setIsLoading(false);
      } else {
        message.error("error activating account");
        setIsLoading(false);
      }
    }
  }

  async function modifyHiddenFeatures() {
    setIsLoading(true);
    const modifyAccountResponse = await VoiceGainAuthSvcApi.modAccount(
      accountId,
      { saAppHiddenFeatures: hiddenFeatures }
    );
    if (modifyAccountResponse.ok) {
      await mutate([fetchAccount, accountId]);
      message.success("Features updated successfully");
      setIsLoading(false);
    } else {
      message.error("error updating features");
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.container}>
      <h2>Speech Analytics</h2>
      {showActivateButton ? (
        <Button
          loading={isLoading}
          disabled={isLoading}
          onClick={handleActivateAccount}
        >
          Activate Account
        </Button>
      ) : (
        <div className={styles.account_active}>Account Active</div>
      )}
      {showActivateButton ? null : (
        <div className={styles.sa_features_container}>
          <div className={styles.hidden_features_title}>Hidden Features</div>
          {saFeatures.map((feature) => (
            <Checkbox
              disabled={isLoading}
              checked={hiddenFeatures.includes(feature.name)}
              onChange={(e) => {
                if (e.target.checked) {
                  setHiddenFeatures([...hiddenFeatures, feature.name]);
                } else {
                  setHiddenFeatures(
                    hiddenFeatures.filter((f) => f !== feature.name)
                  );
                }
              }}
              key={feature.name}
            >
              {feature.label}
            </Checkbox>
          ))}
          <Button
            loading={isLoading}
            disabled={isLoading}
            type="primary"
            onClick={modifyHiddenFeatures}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );
}

export default AccountSA;
